import { faCheck } from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';

import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';

import { FontAwesomeSvgIcon } from 'components/shared';

const Styles = styled.div`
  position: relative;
  height: 0;

  .checkbox {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100%;
  }

  .chip {
    height: 0;
    overflow: hidden;
  }
`;

type Props = {
  checked: boolean;
  label: string;
  onClick: () => void;
};

export default function CellCheckAll({ checked, onClick, label }: Props) {
  return (
    <th>
      <Styles>
        <Checkbox
          size="small"
          className="checkbox"
          checked={checked}
          onClick={onClick}
          icon={<FontAwesomeSvgIcon icon={faCheck} fontSize="small" />}
          checkedIcon={
            <FontAwesomeSvgIcon
              icon={faCheck}
              fontSize="small"
              color="primary"
            />
          }
        />
        <Chip label={label} className="chip" />
      </Styles>
    </th>
  );
}
